import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { DrawerModule } from 'primeng/drawer';

/**
 * Painel lateral "Como funciona a visibilidade" (card 3803, tela `_regras` do protótipo). Abre pelo
 * link no topo da lista de Meetings e pelo rodapé da janela "Visibilidade da call".
 *
 * Texto fixo: descreve as regras que o backend aplica (`MeetingVisibilityRules`). Mudou a regra no
 * backend, mude aqui também. É o `p-drawer` do PrimeNG direto, como o painel de filtros da lista: o
 * design system não tem wrapper de painel lateral.
 */
@Component({
  selector: 'app-meeting-visibility-rules-drawer',
  standalone: true,
  imports: [DrawerModule],
  templateUrl: './meeting-visibility-rules-drawer.component.html',
  styleUrl: './meeting-visibility-rules-drawer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingVisibilityRulesDrawerComponent {
  /** Aberto ou fechado; o pai usa `[(visible)]`. */
  readonly visible = model(false);
}
